import { Navigate } from "react-router-dom";

import { useAuth } from "./AuthProvider";
import { canSeeAny } from "../lib/permissions";

/**
 * Route guard: render children only if the logged-in user has page-level
 * ShowR on at least one of `anyOf`. Otherwise redirect to Today ("/").
 *
 * This makes "hidden in the nav" also mean "not reachable by typing the URL".
 * The backend independently enforces its own rights on each endpoint; this is
 * the front-of-house redirect so a User who types /masters lands back on Today.
 */
export function RequirePage({
  anyOf, children,
}: {
  anyOf: ReadonlyArray<string>;
  children: React.ReactNode;
}) {
  const { me } = useAuth();
  if (!me) return null;                       // still bootstrapping
  if (!canSeeAny(me, anyOf)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
